import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoEvaluation = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	viewBox: "0 0 400 275",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_bdd_10333_38793)",
			children: [/* @__PURE__ */ _jsxs("g", {
				clipPath: "url(#clip0_10333_38793)",
				children: [
					/* @__PURE__ */ _jsx("rect", {
						x: 90.7628,
						y: 65.8064,
						width: 218.474,
						height: 141.663,
						rx: 10.3226,
						fill: "#CACCD8",
						fillOpacity: .2,
						shapeRendering: "crispEdges"
					}),
					/* @__PURE__ */ _jsxs("g", {
						filter: "url(#filter1_dd_10333_38793)",
						children: [
							/* @__PURE__ */ _jsx("rect", {
								width: 20.6452,
								height: 177.419,
								transform: "translate(90.7628 65.8064)",
								fill: "#CACCD8",
								fillOpacity: .5
							}),
							/* @__PURE__ */ _jsx("g", {
								clipPath: "url(#clip1_10333_38793)",
								children: /* @__PURE__ */ _jsx("path", {
									fillRule: "evenodd",
									clipRule: "evenodd",
									d: "M101.085 76.7742C102.423 76.7742 103.607 76.8829 104.327 77.0495C105.762 77.3516 106.893 78.4854 107.194 79.925C107.36 80.6471 107.469 81.834 107.469 83.1758C107.469 84.5176 107.36 85.7045 107.194 86.4266C106.893 87.8662 105.762 89 104.327 89.3021C103.607 89.4687 102.423 89.5774 101.085 89.5774C99.7474 89.5774 98.5638 89.4687 97.8438 89.3021C96.4083 89 95.2778 87.8662 94.9766 86.4266C94.8104 85.7045 94.702 84.5176 94.702 83.1758C94.702 81.834 94.8104 80.6471 94.9766 79.925C95.2778 78.4854 96.4083 77.3516 97.8438 77.0495C98.5638 76.8829 99.7474 76.7742 101.085 76.7742ZM101.928 86.0294C102.241 86.0952 102.498 86.3129 102.619 86.6021C102.659 86.6975 102.756 86.756 102.859 86.7466C102.89 86.7437 102.916 86.7412 102.938 86.7391C103.438 86.6891 103.831 86.6194 104.059 86.5381L104.061 86.5375C104.214 86.4797 104.323 86.3312 104.323 86.1572C104.323 86.1528 104.323 86.1485 104.323 86.1442L104.322 86.1228L104.321 86.1179C104.321 86.1133 104.321 86.1089 104.321 86.1047C104.282 85.5822 103.965 84.3589 103.493 82.9627C102.952 81.3666 102.387 80.0744 102.133 79.8224C102.092 79.7803 102.045 79.7443 101.993 79.7169C101.973 79.7053 101.947 79.6942 101.917 79.6837L101.914 79.6828C101.747 79.6262 101.438 79.5881 101.085 79.5881C100.732 79.5881 100.423 79.6262 100.256 79.6829L100.254 79.6837C100.223 79.6942 100.198 79.7053 100.177 79.7169C100.125 79.7443 100.079 79.7799 100.038 79.8224C99.7831 80.0744 99.2181 81.3666 98.6778 82.9627C98.2052 84.3589 97.8888 85.5822 97.8498 86.1047C97.8497 86.1089 97.8494 86.1133 97.849 86.1179L97.8486 86.1228L97.8473 86.1442C97.8473 86.1464 97.8472 86.1486 97.8472 86.1508C97.8471 86.153 97.8471 86.1551 97.8471 86.1572C97.8471 86.3312 97.9563 86.4797 98.1097 86.5375L98.1111 86.5381C98.3397 86.6195 98.7331 86.6892 99.2337 86.7392C99.2531 86.7411 99.276 86.7433 99.3026 86.7458C99.41 86.7557 99.5116 86.6951 99.5539 86.5959C99.6761 86.3098 99.9318 86.0947 100.242 86.0294C100.43 85.986 100.737 85.9578 101.085 85.9578C101.433 85.9578 101.741 85.986 101.928 86.0294Z",
									fill: "#F7F8FC"
								})
							}),
							/* @__PURE__ */ _jsx("rect", {
								x: 95.9241,
								y: 100.545,
								width: 10.3226,
								height: 10.3226,
								rx: 2.09732,
								fill: "#F7F8FC"
							}),
							/* @__PURE__ */ _jsx("rect", {
								x: 95.9241,
								y: 118.61,
								width: 10.3226,
								height: 10.3226,
								rx: 2.09732,
								fill: "#F7F8FC"
							}),
							/* @__PURE__ */ _jsx("rect", {
								x: 95.9241,
								y: 136.674,
								width: 10.3226,
								height: 10.3226,
								rx: 2.09732,
								fill: "#F7F8FC"
							}),
							/* @__PURE__ */ _jsx("rect", {
								x: 95.9241,
								y: 154.739,
								width: 10.3226,
								height: 10.3226,
								rx: 2.09732,
								fill: "#F7F8FC"
							}),
							/* @__PURE__ */ _jsx("rect", {
								x: 95.9241,
								y: 172.803,
								width: 10.3226,
								height: 10.3226,
								rx: 2.09732,
								fill: "#F7F8FC"
							})
						]
					}),
					/* @__PURE__ */ _jsxs("g", {
						clipPath: "url(#clip2_10333_38793)",
						children: [
							/* @__PURE__ */ _jsx("rect", {
								width: 197.829,
								height: 46.3624,
								transform: "translate(111.408 65.8064)",
								fill: "#CACCD8",
								fillOpacity: .25
							}),
							/* @__PURE__ */ _jsx("rect", {
								x: 127.892,
								y: 82.2908,
								width: 30.9082,
								height: 6.18165,
								rx: 3.09082,
								fill: "#F7F8FC"
							}),
							/* @__PURE__ */ _jsx("rect", {
								x: 127.892,
								y: 92.5935,
								width: 41.211,
								height: 3.09082,
								rx: 1.54541,
								fill: "#F7F8FC"
							})
						]
					})
				]
			}), /* @__PURE__ */ _jsx("rect", {
				x: 90.634,
				y: 65.6776,
				width: 218.732,
				height: 141.92,
				rx: 10.4514,
				stroke: "#EAEBF0",
				strokeWidth: .257569,
				shapeRendering: "crispEdges"
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter2_bd_10333_38793)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 44.3633,
					y: 100.645,
					width: 42.6685,
					height: 42.6685,
					rx: 21.3342,
					transform: "rotate(5 44.3633 100.645)",
					fill: "url(#paint0_linear_10333_38793)",
					fillOpacity: .6,
					shapeRendering: "crispEdges"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 44.6565,
					y: 100.994,
					width: 42.0233,
					height: 42.0233,
					rx: 21.0117,
					transform: "rotate(5 44.6565 100.994)",
					stroke: "url(#paint1_linear_10333_38793)",
					strokeOpacity: .5,
					strokeWidth: .645161,
					shapeRendering: "crispEdges"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .5,
					d: "M59.1404 127.671C58.835 127.307 58.8825 126.764 59.2464 126.459L67.154 119.824C67.5179 119.518 68.0605 119.566 68.3659 119.93C68.6713 120.294 68.6238 120.836 68.2599 121.141L60.3523 127.777C59.9884 128.082 59.4458 128.035 59.1404 127.671Z",
					fill: "#3086EE"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M67.6395 128.408C68.0034 128.103 68.0509 127.56 67.7455 127.196L61.0825 119.255C60.7771 118.891 60.2345 118.844 59.8706 119.149C59.5067 119.455 59.4592 119.997 59.7646 120.361L66.4276 128.302C66.733 128.666 67.2756 128.713 67.6395 128.408Z",
					fill: "#3086EE"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter3_bd_10333_38793)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 290.324,
					y: 78.2832,
					width: 48.2059,
					height: 48.2059,
					rx: 24.103,
					transform: "rotate(-15 290.324 78.2832)",
					fill: "url(#paint2_linear_10333_38793)",
					fillOpacity: .6,
					shapeRendering: "crispEdges"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 290.719,
					y: 78.5113,
					width: 47.5608,
					height: 47.5608,
					rx: 23.7804,
					transform: "rotate(-15 290.719 78.5113)",
					stroke: "url(#paint3_linear_10333_38793)",
					strokeOpacity: .5,
					strokeWidth: .645161,
					shapeRendering: "crispEdges"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M319.266 98.1533C321.331 97.6 322.556 95.4774 322.003 93.4124C321.45 91.3474 319.327 90.1219 317.262 90.6752C315.197 91.2285 313.972 93.3511 314.525 95.4162C315.078 97.4812 317.201 98.7067 319.266 98.1533ZM319.934 100.646C323.375 99.7238 325.418 96.1862 324.496 92.7445C323.574 89.3028 320.036 87.2603 316.594 88.1825C313.152 89.1047 311.11 92.6424 312.032 96.0841C312.954 99.5258 316.492 101.568 319.934 100.646Z",
					fill: "#3086EE"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .5,
					d: "M323.094 98.6928C323.669 98.0424 324.108 97.2811 324.384 96.4579L328.119 98.6145C328.737 98.9709 328.948 99.76 328.592 100.377C328.235 100.994 327.446 101.206 326.829 100.849L323.094 98.6928Z",
					fill: "#3086EE"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter4_bd_10333_38793)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 292.258,
					y: 186.945,
					width: 42.6685,
					height: 42.6685,
					rx: 21.3342,
					transform: "rotate(-5 292.258 186.945)",
					fill: "url(#paint4_linear_10333_38793)",
					fillOpacity: .6,
					shapeRendering: "crispEdges"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 292.607,
					y: 187.239,
					width: 42.0233,
					height: 42.0233,
					rx: 21.0117,
					transform: "rotate(-5 292.607 187.239)",
					stroke: "url(#paint5_linear_10333_38793)",
					strokeOpacity: .5,
					strokeWidth: .645161,
					shapeRendering: "crispEdges"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M323.811 200.979C324.104 201.166 324.256 201.512 324.195 201.854L323.745 204.395C323.662 204.863 323.216 205.175 322.748 205.092L320.207 204.642C319.864 204.581 319.592 204.32 319.517 203.981C319.442 203.641 319.579 203.289 319.864 203.09L322.855 200.999C323.141 200.8 323.518 200.792 323.811 200.979ZM306.826 208.243C306.924 207.778 307.38 207.481 307.845 207.578L310.37 208.108C310.711 208.18 310.975 208.449 311.039 208.791C311.103 209.133 310.955 209.48 310.664 209.67L307.608 211.666C307.317 211.856 306.94 211.852 306.653 211.656C306.365 211.46 306.225 211.11 306.296 210.769L306.826 208.243Z",
					fill: "#3086EE"
				}),
				/* @__PURE__ */ _jsxs("g", {
					opacity: .5,
					children: [/* @__PURE__ */ _jsx("path", {
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M314.659 199.493C311.592 199.761 309.156 202.227 308.676 205.401C308.604 205.87 308.166 206.194 307.696 206.123C307.227 206.051 306.903 205.613 306.974 205.143C307.56 201.271 310.567 198.124 314.509 197.779C318.451 197.434 321.959 200.011 323.208 203.723C323.36 204.173 323.118 204.661 322.667 204.813C322.217 204.964 321.729 204.722 321.578 204.272C320.554 201.23 317.726 199.225 314.659 199.493Z",
						fill: "#3086EE"
					}), /* @__PURE__ */ _jsx("path", {
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M307.85 207.885C308.301 207.733 308.789 207.975 308.94 208.425C309.964 211.467 312.792 213.472 315.859 213.204C318.926 212.936 321.362 210.47 321.842 207.297C321.913 206.827 322.352 206.504 322.822 206.575C323.291 206.646 323.615 207.084 323.543 207.554C322.957 211.426 319.951 214.573 316.009 214.918C312.067 215.263 308.559 212.686 307.31 208.974C307.158 208.524 307.4 208.036 307.85 207.885Z",
						fill: "#3086EE"
					})]
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_bdd_10333_38793",
				x: 59.5375,
				y: 39.7424,
				width: 280.925,
				height: 214.436,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						in: "BackgroundImageFix",
						stdDeviation: 12.9032
					}),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "SourceAlpha",
						operator: "in",
						result: "effect1_backgroundBlur_10333_38793"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 15.4839 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 15.4839 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.082353 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.05 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_backgroundBlur_10333_38793",
						result: "effect2_dropShadow_10333_38793"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -2.58065,
						dy: 2.58065
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3.87097 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0823529 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.05 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect2_dropShadow_10333_38793",
						result: "effect3_dropShadow_10333_38793"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect3_dropShadow_10333_38793",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_dd_10333_38793",
				x: 87.4071,
				y: 64.1285,
				width: 27.3566,
				height: 184.131,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: .419464 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .419464 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.00392157 0 0 0 0 0.14902 0 0 0 0 0.207843 0 0 0 0.05 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_10333_38793"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1.67785 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.67785 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.00392157 0 0 0 0 0.14902 0 0 0 0 0.207843 0 0 0 0.05 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_10333_38793",
						result: "effect2_dropShadow_10333_38793"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect2_dropShadow_10333_38793",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_bd_10333_38793",
				x: 9.67673,
				y: 85.1607,
				width: 108.16,
				height: 108.16,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						in: "BackgroundImageFix",
						stdDeviation: 3.87097
					}),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "SourceAlpha",
						operator: "in",
						result: "effect1_backgroundBlur_10333_38793"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 15.4839 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 15.4839 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.082353 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.05 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_backgroundBlur_10333_38793",
						result: "effect2_dropShadow_10333_38793"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect2_dropShadow_10333_38793",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter3_bd_10333_38793",
				x: 259.356,
				y: 50.3228,
				width: 120.975,
				height: 120.976,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						in: "BackgroundImageFix",
						stdDeviation: 3.87097
					}),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "SourceAlpha",
						operator: "in",
						result: "effect1_backgroundBlur_10333_38793"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 15.4839 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 15.4839 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.082353 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.05 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_backgroundBlur_10333_38793",
						result: "effect2_dropShadow_10333_38793"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect2_dropShadow_10333_38793",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter4_bd_10333_38793",
				x: 261.29,
				y: 167.743,
				width: 108.16,
				height: 108.16,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						in: "BackgroundImageFix",
						stdDeviation: 3.87097
					}),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "SourceAlpha",
						operator: "in",
						result: "effect1_backgroundBlur_10333_38793"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 15.4839 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 15.4839 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.082353 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.05 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_backgroundBlur_10333_38793",
						result: "effect2_dropShadow_10333_38793"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect2_dropShadow_10333_38793",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_10333_38793",
				x1: 65.6975,
				y1: 100.645,
				x2: 65.6975,
				y2: 143.313,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#C9C9C9",
					stopOpacity: .5
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#EAEBF0",
					stopOpacity: .5
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_10333_38793",
				x1: 65.6975,
				y1: 100.645,
				x2: 65.6975,
				y2: 143.313,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#CACCD8" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#6B6C72",
					stopOpacity: .25
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_10333_38793",
				x1: 314.427,
				y1: 78.2832,
				x2: 314.427,
				y2: 126.489,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#C9C9C9",
					stopOpacity: .5
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#EAEBF0",
					stopOpacity: .5
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_10333_38793",
				x1: 314.427,
				y1: 78.2832,
				x2: 314.427,
				y2: 126.489,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#CACCD8" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#6B6C72",
					stopOpacity: .25
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_10333_38793",
				x1: 313.592,
				y1: 186.945,
				x2: 313.592,
				y2: 229.614,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#C9C9C9",
					stopOpacity: .5
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#EAEBF0",
					stopOpacity: .5
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint5_linear_10333_38793",
				x1: 313.592,
				y1: 186.945,
				x2: 313.592,
				y2: 229.614,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#CACCD8" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#6B6C72",
					stopOpacity: .25
				})]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_10333_38793",
				children: /* @__PURE__ */ _jsx("rect", {
					x: 90.7628,
					y: 65.8064,
					width: 218.474,
					height: 141.663,
					rx: 10.3226,
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip1_10333_38793",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 12.7668,
					height: 12.8033,
					fill: "white",
					transform: "translate(94.702 76.7742)"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip2_10333_38793",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 197.829,
					height: 141.663,
					fill: "white",
					transform: "translate(111.408 65.8064)"
				})
			})
		] })
	]
});
export default SvgNoEvaluation;
